import { render, staticRenderFns } from "./SignalsComponent.vue?vue&type=template&id=5f778d3a"
import script from "./SignalsComponent.vue?vue&type=script&lang=js"
export * from "./SignalsComponent.vue?vue&type=script&lang=js"
import style0 from "./SignalsComponent.vue?vue&type=style&index=0&id=5f778d3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports